import Vue from "vue";
import VueI18n from "vue-i18n";
import ENGLISH_TRANSLATIONS from "./en";
import SWEDISH_TRANSLATIONS from "./sv";

Vue.use(VueI18n);

const TRANSLATIONS = {
  en: ENGLISH_TRANSLATIONS,
  sv: SWEDISH_TRANSLATIONS,
};
export default new VueI18n({
  locale: "en", //navigator.language.split("-")[0],
  fallbackLocale: "en",

  messages: TRANSLATIONS,
});

export const languages = [
  { locale: "en", text: "English" },
  { locale: "sv", text: "Svenska" },
];
